import { render, staticRenderFns } from "./PartyBuild.vue?vue&type=template&id=24121e4a&scoped=true&"
import script from "./PartyBuild.vue?vue&type=script&lang=js&"
export * from "./PartyBuild.vue?vue&type=script&lang=js&"
import style0 from "./PartyBuild.vue?vue&type=style&index=0&id=24121e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24121e4a",
  null
  
)

export default component.exports